import React from "react";

import DisplayTypeSet from "../../types/system/DisplayTypeSet";
import { DisplaySettingSection } from "../../types/system/DisplayType";
import {
    FlexBehaviour,
    FlexDirection,
    Position,
    Side,
} from "../../types/system/Layout";
import DisplaySettingReportSection from "./DisplaySettingReportSection";

import "./DisplaySettings.scss";
import GeneralContainer from "../containers/GeneralContainer";

interface DisplaySettingReportsProps {
    workingDisplay: DisplayTypeSet;
}

class DisplaySettingReports extends React.Component<DisplaySettingReportsProps> {
    render() {
        return (
            <GeneralContainer
                position={Position.Sticky}
                bufferSide={Side.Left}
                flex={FlexDirection.Column}
                flexBehaviour={FlexBehaviour.Min}
                flexSpaced={true}>
                {this.props.workingDisplay.types
                    .filter(
                        item => item.section === DisplaySettingSection.Reports,
                    )
                    .map((setting, index) => (
                        <DisplaySettingReportSection
                            key={index}
                            setting={setting}
                        />
                    ))}
            </GeneralContainer>
        );
    }
}

export default DisplaySettingReports;
